var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"d-block h-100"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{ref:"editor"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }